var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#401d0c",
    d: "M17.45 4.125h-4.512v-1.35a.525.525 0 0 0-.526-.525h-.825a.525.525 0 0 0-.524.525v1.35H6.549A3.55 3.55 0 0 0 3 7.675v2.114a8.773 8.773 0 0 0 8.773 8.774h.64a.525.525 0 0 0 .524-.525v-.826a.525.525 0 0 0-.524-.524h-.64a6.9 6.9 0 0 1-6.898-6.899V7.674A1.674 1.674 0 0 1 6.549 6h10.902a1.674 1.674 0 0 1 1.674 1.674v2.263a6.4 6.4 0 0 1-.187 1.527.523.523 0 0 0 .345.626l.787.257a.524.524 0 0 0 .671-.366c.17-.668.258-1.354.259-2.043V7.674a3.55 3.55 0 0 0-3.55-3.549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5.95 5.398 1.698.67a.19.19 0 0 1 .119.174.19.19 0 0 1-.119.174l-1.699.67a2.37 2.37 0 0 0-1.33 1.329l-.668 1.688a.188.188 0 0 1-.28.086.2.2 0 0 1-.07-.087l-.669-1.687a2.36 2.36 0 0 0-1.329-1.33l-1.688-.669a.188.188 0 0 1 0-.349l1.688-.669a2.36 2.36 0 0 0 1.33-1.33l.669-1.687a.188.188 0 0 1 .349 0l.669 1.688a2.37 2.37 0 0 0 1.33 1.33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.9927c559af994da3d5a1aef9f9f5cdcc.svg";
export { ForwardRef as ReactComponent };